import PeriodType from "@/models/Shared/PeriodType";
import BaseProductSettings from "@/models/Products/ProductSettings/BaseProductSettings";
import Amount from "@/models/Shared/Amount";
import FundingWindowTriggerType from "@/models/Products/ProductSettings/DefaultSettings/FixedTerm/FundingWindowTriggerType";

export default class DepositFixedTermSettings extends BaseProductSettings {
    termPeriodType: PeriodType = PeriodType.Year;
    termPeriodValue: number = 1;
    minimumBalance: Amount = new Amount();
    maximumBalance: Amount = new Amount();
    initialDepositWindowPeriodType: PeriodType = PeriodType.Month;
    initialDepositWindowPeriodValue: number = 1;
    fundingWindowTriggerType: FundingWindowTriggerType = FundingWindowTriggerType.FirstDeposit;
    fundingWindowPeriodType: PeriodType = PeriodType.Month;
    fundingWindowPeriodValue: number = 1;
}